import agent from 'superagent'
import agentIntercept from "superagent-use";

const req = agentIntercept(agent);
req.use(() => {
    if(typeof sendMessageToParent === undefined) {
        sendMessageToParent('ping');
        sendMessageToParent('resetTimeout');
    }
    else {
        var data = {
            type: 'resetTimeout',
            app: 'eci'
        }

        try {
            var message = JSON.stringify(data);
            window.parent.postMessage(message, getCurrentHost());
        } catch(err) {
            // Swallow the error
            console.log(err)
        }
    }
});

export const request = req;